import { Component } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DirectSubscriptionService } from '../../services/direct-subscription.service';
import { DirectService, InstantBookSettings } from '../../services/direct.service';

@Component({
  standalone: false,
  templateUrl: './direct-instant-book.component.html',
  styleUrls: ['./direct-instant-book.component.scss'],
})
export class DirectInstantBookComponent {
  instantBookSettings$ = this.direct.fetchInstantBookSettings();
  loading$: Observable<boolean> = this.instantBookSettings$.pipe(map((settings) => !settings));
  saving$ = new BehaviorSubject(false);
  recentlySaved: boolean;

  isPremium$ = this.sub.isPremium$;

  constructor(
    private direct: DirectService,
    private sub: DirectSubscriptionService
  ) { }

  saveChanges(settings: InstantBookSettings) {
    this.saving$.next(true);

    this.direct.saveInstantBookSettings(settings).subscribe((res) => {
      this.saving$.next(false);
      this.recentlySaved = true;
      setTimeout(() => {
        this.recentlySaved = false;
      }, 3000);
    });
  }
}
